import { buildPatternsHtml } from './reference.js';
import { enableDrag } from '../ui/draggable.js';

let built = false;

export function showHands() {
  if (!built) {
    document.getElementById('handsBody').innerHTML = buildPatternsHtml();
    built = true;
  }
  document.getElementById('handsOverlay').classList.add('show');
}

export function hideHands() {
  document.getElementById('handsOverlay').classList.remove('show');
}

export function wireHands() {
  document.getElementById('btnHandsClose').addEventListener('click', hideHands);
  document.getElementById('btnHandsMin').addEventListener('click', () => {
    const box = document.getElementById('handsBox');
    const min = box.classList.toggle('minimized');
    document.getElementById('btnHandsMin').textContent = min ? '+' : '–';
    document.getElementById('btnHandsMin').title = min ? 'Expand' : 'Minimize';
  });
  enableDrag({ panelId: 'handsBox', handleId: 'handsHead' });
}
